/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * プレスリリース作成・更新・自動保存成功時のレスポンスデータ
 * @export
 * @interface PressReleaseSuccessResponseData
 */
export interface PressReleaseSuccessResponseData {
    /**
     * プレスリリースid
     * @type {number}
     * @memberof PressReleaseSuccessResponseData
     */
    releaseId: number;
    /**
     * コンフリクト検知用のタイムスタンプ
     * @type {number}
     * @memberof PressReleaseSuccessResponseData
     */
    editStartedAt: number;
}

export function PressReleaseSuccessResponseDataFromJSON(json: any): PressReleaseSuccessResponseData {
    return PressReleaseSuccessResponseDataFromJSONTyped(json, false);
}

export function PressReleaseSuccessResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressReleaseSuccessResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'releaseId': json['release_id'],
        'editStartedAt': json['edit_started_at'],
    };
}

export function PressReleaseSuccessResponseDataToJSON(value?: PressReleaseSuccessResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'release_id': value.releaseId,
        'edit_started_at': value.editStartedAt,
    };
}

